/**
 * Re-ordering a list by dragging (task steps in the task editor, 2026-10-13). Pure helpers;
 * the component only measures the rows and calls these.
 */

/** A copy of `list` with the item at `from` moved to `to` (indexes are clamped). */
export function moveItem<T>(list: readonly T[], from: number, to: number): T[] {
  const out = list.slice();
  if (from < 0 || from >= out.length) return out;
  const target = Math.max(0, Math.min(out.length - 1, to));
  if (target === from) return out;
  const [item] = out.splice(from, 1);
  out.splice(target, 0, item);
  return out;
}

/**
 * Where the dragged row belongs for a pointer at `y`: the row whose box the pointer is over,
 * the first row above the list, the last row below it. `rows` are the rows' boxes in list order.
 */
export function dropIndexForY(rows: ReadonlyArray<{ top: number; bottom: number }>, y: number): number {
  if (!rows.length) return 0;
  if (y < rows[0].top) return 0;
  for (let i = 0; i < rows.length; i++) if (y < rows[i].bottom) return i;
  return rows.length - 1;
}
